import User from '@/domain/user/user.entity';
import { ProjectMember } from '@/domain/project/project-with-members.entity';

export default class ProjectPersist {
  id?: string;

  name: string;

  description?: string;

  projectUsers: User[];

  members: ProjectMember[];

  businessUnitId: string;

  costCenterId: string;

  manager: User;

  allowMandalaEditClosedVsts: boolean = false;

  constructor(obj: any = {}) {
    if (obj.id) this.id = obj.id;
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.projectUsers = obj.projectUsers || [];
    this.members = obj.members || [];
    this.businessUnitId = obj.businessUnitId || '';
    this.costCenterId = obj.costCenterId || '';
    this.manager = obj.manager || {};
    this.allowMandalaEditClosedVsts = obj.allowMandalaEditClosedVsts || false;
  }

  public static of(value: any): ProjectPersist {
    return new ProjectPersist(value || {});
  }

  public static ofList(response: any): ProjectPersist[] {
    return response.data.map(this.of);
  }
}
